/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AuthorityOption from './AuthorityOption';
import GroupOption from './GroupOption';
import RoleOption from './RoleOption';
import SensorTypeOption from './SensorTypeOption';
import TankTypeOption from './TankTypeOption';

/**
* The GetOptionsResponse model module.
* @module model/GetOptionsResponse
* @version 2020-12-7
*/
export default class GetOptionsResponse {
    /**
    * Constructs a new <code>GetOptionsResponse</code>.
    * 選択項目取得レスポンス
    * @alias module:model/GetOptionsResponse
    * @class
    * @param result {module:model/GetOptionsResponse.ResultEnum} 
    */

    constructor(result) {
        
        
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>GetOptionsResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/GetOptionsResponse} obj Optional instance to populate.
    * @return {module:model/GetOptionsResponse} The populated <code>GetOptionsResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GetOptionsResponse();
                        
            
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
            if (data.hasOwnProperty('autorities')) {
                obj['autorities'] = ApiClient.convertToType(data['autorities'], [AuthorityOption]);
            }
            if (data.hasOwnProperty('groups')) {
                obj['groups'] = ApiClient.convertToType(data['groups'], [GroupOption]);
            }
            if (data.hasOwnProperty('groupRoles')) {
                obj['groupRoles'] = ApiClient.convertToType(data['groupRoles'], [RoleOption]);
            }
            if (data.hasOwnProperty('userRoles')) {
                obj['userRoles'] = ApiClient.convertToType(data['userRoles'], [RoleOption]);
            }
            if (data.hasOwnProperty('sensorTypes')) {
                obj['sensorTypes'] = ApiClient.convertToType(data['sensorTypes'], [SensorTypeOption]);
            }
            if (data.hasOwnProperty('tankTypes')) {
                obj['tankTypes'] = ApiClient.convertToType(data['tankTypes'], [TankTypeOption]);
            }
        }
        return obj;
    }

    /**
    * @member {module:model/GetOptionsResponse.ResultEnum} result
    */
    'result' = undefined;
    /**
    * 権限
    * @member {Array.<module:model/AuthorityOption>} autorities
    */
    'autorities' = undefined;
    /**
    * グループ
    * @member {Array.<module:model/GroupOption>} groups
    */
    'groups' = undefined;
    /**
    * グループロール
    * @member {Array.<module:model/RoleOption>} groupRoles
    */
    'groupRoles' = undefined;
    /**
    * ユーザーロール
    * @member {Array.<module:model/RoleOption>} userRoles
    */
    'userRoles' = undefined;
    /**
    * センサータイプ
    * @member {Array.<module:model/SensorTypeOption>} sensorTypes
    */
    'sensorTypes' = undefined;
    /**
    * タンクタイプ
    * @member {Array.<module:model/TankTypeOption>} tankTypes
    */
    'tankTypes' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
